import { FirearmAssignablePersonService } from './firearm-assignable-person.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { FIREARM_ASSIGNABLE_PERSON_TYPE, FirearmAssignablePerson } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class FirearmAssignablePersonResolverBase implements Resolve<FirearmAssignablePerson> {

  constructor(protected service: FirearmAssignablePersonService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<FirearmAssignablePerson> {
    const key: string = FIREARM_ASSIGNABLE_PERSON_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



